import BaseClass from "../../libs/base/BaseClass";
import ThingsManagerClass from "../../libs/base/ThingsManagerClass";
import Util from "../../libs/util/Util";
import gsap from "gsap";

/**
 * ボタンのタップ時のアニメーションを管理
 */
class RippleClass extends BaseClass{
    constructor(_target) {
        super();
        this.name = "RippleClass";

        this.CL_ACTIVE = "isActive";

        this.target = _target;

        this.onClickListener = this.onClick.bind(this);

        this.offset = null;

        this.isAnimation = false;
    }

    onCreate() {
        let html = '<span class="js-ripple_effect"><span></span></span>';

        let insertTarget = this.target;

        if((this.target.attr("class")).indexOf("css_radio_button") !== -1){
            insertTarget = $("> span",this.target);
        }

        this.circleWrap = ($(".js-ripple_effect",insertTarget).length < 1)? $(html).prependTo(insertTarget) : $(".js-ripple_effect",insertTarget) ;
        this.circle = $("span",this.circleWrap);


        let events = "";
        if(Util.isTouch){
            events = "touchstart";
        } else if(Util.isPointer){
            events = "MSPointerDown pointerdown";
        } else {
            events = "mousedown";
        }
        this.target.on(events,this.onClickListener);
    }

    onResize(){
        this.offset = this.target.offset();
    }

    onClick(e){
        if(gsap.isTweening(this.circle)){
            gsap.killTweensOf(this.circle);
            this.circle.css({opacity:"",width:"","padding-bottom":""});
        }
        this.onResize();

        const x = e.pageX - this.offset.left;
        const y = e.pageY - this.offset.top;
        this.circle.css({top:y,left:x});

        const target = this.circle;
        const time = 0.6;
        const ease = "power4.out";

        const t1 = gsap.timeline();
        t1.to(target,time*0.25,{opacity:1});
        t1.to(target,time*0.75,{opacity:0});
        gsap.to(target,{duration:time,width:"200%","padding-bottom":"200%",ease:ease,onComplete:()=>{
                this.isAnimation = false;
                target.css({opacity:"",width:"","padding-bottom":""});
            }
        });
    }
}

export default class RippleManagerClass extends ThingsManagerClass{
    constructor(_target){
        super();
        this.name = "RippleManagerClass";

        this._target = (_target)? _target : "body";
    }

    onCreate() {
        this.things = [];

        $(".js-ripple",this._target).each((i,e)=>{
            this.things.push(new RippleClass($(e)));
        });

        super.onCreate();
    }

    onRemove() {
        super.onRemove();
    }

}